import { useState, useEffect } from 'react'
import { HiHome } from 'react-icons/hi2';
import { HiSearch , HiThumbUp} from 'react-icons/hi';
import AnimeList from './AnimeCard';
import MainBody from './MainBody';
import { Route, NavLink, HashRouter, BrowserRouter } from "react-router-dom";




const Header = () =>{

  return(
    <div className="m-5 hidden lg:block backdrop-blur-md backdrop-brightness-110 rounded-xl bg-[#1E1F25] border-[rgb(48,54,61)] border-[0.00625rem]">
      <div className="relative p-4  h-full max-h-full">
        <div className="text-2xl py-1"> 
          <div className="flex flex items-center justify-center gap-3  ">
            <div  className="bg-[#1B64F2] rounded-full font-bold p-2">
            <HiHome/> 
            </div>
            <div className="bg-[#1B64F2] p-1 rounded-full px-3 my-5 font-bold"><NavLink to="/" className="text-center">Home</NavLink></div>
          </div>
          <div className="bg-[#272933] mt-10 p-2 rounded-xl backdrop-blur-md backdrop-brightness-110  border-[rgb(48,54,68)] border-[0.00625rem]">
            <p className="text-center font-bold">Search</p>
            <div className="flex items-center gap-3 font-medium bg-[#141518] p-1 rounded-full px-3 mt-2"><HiSearch/> <NavLink to="/search">Anime</NavLink></div>
            <div className="flex items-center gap-3 font-medium bg-[#141518] p-1 rounded-full px-3 mt-2"><HiSearch/> <NavLink to="/search/character">Character</NavLink> </div>
          </div>
            <div className="flex items-center gap-3 font-medium bg-[#272933] mt-10 p-1 rounded-full px-3 "><HiThumbUp/><NavLink to="/recom">Suggestion</NavLink></div>
        </div>
      </div>
    </div>
  )
}





const App = () => {

    
 
  

  // useEffect(() => {
  //   // searchAnimes('Jujutsu Kaisen');
  // },[]);
  

  return (
   <BrowserRouter>
    <div className="lg:h-screen h-full text-white bg-[#141518] grid lg:grid-cols-5 max-w-8xl">
      <Header />
      <MainBody />
    </div>
   </BrowserRouter>
  );
}



export default App;
